/** Модуль аналізу всієї платформи (прототип v4 «Бізнес-аналіз», ключ `ba`): його записи живуть в одному робочому просторі. */
export const PLATFORM_ANALYSIS_MODULE = 'ba';
